import React from "react";
import { MessageCircle } from "lucide-react";
import { uunConfig, validateWhatsAppUrl } from "../config/uunConfig";
import { trackCta } from "../ctaTracking";
import "./WhatsAppCommunityCard.css";

export default function WhatsAppCommunityCard({
  title = "Join the UUN WhatsApp Community",
  description = "Stay updated with local events, activities, services, opportunities and community projects from Urban Unity Network.",
  showQrCode = true,
  showOptionalNotice = false,
  compact = false,
  source = "website",
  whatsappUrl,
}) {
  const url = validateWhatsAppUrl(whatsappUrl || uunConfig.whatsappCommunityUrl);
  if (!url) return null;

  const titleId = `whatsapp-community-title-${String(source).replace(/[^a-z0-9_-]/gi, "-")}`;
  return (
    <section className={`whatsapp-community-card${compact ? " whatsapp-community-card--compact" : ""}`} aria-labelledby={titleId}>
      <MessageCircle className="whatsapp-community-card__icon" aria-hidden="true" />
      <h2 id={titleId}>{title}</h2>
      <p>{description}</p>
      <p className="whatsapp-community-card__guidance">On your phone, tap the button below to join. If you are viewing this on another device, scan the QR code.</p>
      <a href={url} target="_blank" rel="noopener noreferrer" data-cta={`whatsapp-${source}`} onClick={() => trackCta(`whatsapp-${source}`, url)} className="cv-button whatsapp-community-card__button">Join the WhatsApp Community</a>
      {showQrCode && <div className="whatsapp-community-card__qr" style={{ width: "100%", textAlign: "center" }}>
        <p>Viewing on another device? Scan this QR code with WhatsApp.</p>
        <a href={url} target="_blank" rel="noopener noreferrer" data-qr-value={url} aria-label="Open the Urban Unity Network WhatsApp invitation" style={{ display: "block", marginLeft: "auto", marginRight: "auto" }}>
          <img src={uunConfig.whatsappQrImageUrl} alt="QR code to join the Urban Unity Network WhatsApp Community" style={{ marginLeft: "auto", marginRight: "auto" }} />
        </a>
      </div>}
      {showOptionalNotice && <p className="whatsapp-community-card__notice">Joining WhatsApp is optional and is not required to receive your food token.</p>}
    </section>
  );
}
